import React from "react";
import Chart from "./Chart";
import { getPermissionObject, translate } from "../../utils/useful";
import moment from "moment";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

class TimeBasedReportWidget extends React.Component {
    state = {
        selectedPeriod: 'month' // Default to last month
    }

    render() {
        const widget = this.props.widget || this.props.data
        const variables = this.props.variables || {}
        const chartType = widget?.type || 'doughnut'
        
        // Prepare data for Chart component
        let appletValue = variables.applet || widget.postBody?.applet
        
        // Remove {{applet}} placeholder if present and no applet provided
        if (appletValue && typeof appletValue === 'string' && appletValue.includes('{{applet}}')) {
            appletValue = variables.applet || null
        }

        // Build filter - include postBody filters but only add applet if provided
        const filter = { ...(widget.postBody || {}) }
        
        // Only add applet to filter if it's provided (for branch-specific widgets)
        if (appletValue) {
            filter.applet = appletValue
        } else {
            delete filter.applet
        }

        // Add time filter based on selected period
        const now = moment()
        let startDate
        
        switch (this.state.selectedPeriod) {
            case 'week':
                startDate = now.clone().subtract(1, 'week').startOf('day').valueOf()
                break
            case 'month':
                startDate = now.clone().subtract(1, 'month').startOf('day').valueOf()
                break
            case '3months':
                startDate = now.clone().subtract(3, 'months').startOf('day').valueOf()
                break
            case '6months':
                startDate = now.clone().subtract(6, 'months').startOf('day').valueOf()
                break
            default:
                startDate = null
        }
        
        if (startDate) {
            filter['uDate'] = { $gte: startDate }
        }

        // TODO: Backend permissions - Currently commented out for backend permission implementation
        // Add user filter if user has "self" permission
        // const permissionRoot = variables?.permissionRoot
        // if (permissionRoot && this.props.user?.info) {
        //     const userPermissions = this.props.user.info.permissions || []
        //     let hasSelfPermission = false
        //     
        //     // Check if user has "self" permission
        //     for (let i = 0; i < userPermissions.length; i++) {
        //         const userPermission = userPermissions[i].permissions
        //         const permResult = getPermissionObject(userPermission, permissionRoot + '.self')
        //         if (permResult?.allowed) {
        //             hasSelfPermission = true
        //             break
        //         }
        //     }
        //     
        //     // If user has "self" permission, filter by their user ID
        //     if (hasSelfPermission && this.props.user.info._id) {
        //         filter.user = this.props.user.info._id
        //     }
        // }
        
        // For now, if user has "self" permission (checked in AdminWidgetsPage), send user as filter
        // This will be handled by backend permissions later
        if (this.props.user?.info?._id) {
            // Backend will handle permission-based filtering
            // filter.user = this.props.user.info._id // Uncomment when backend is ready
        }

        const chartData = {
            filter: filter,
            groupBy: 'values.lastFollowUpResult',
            frame: widget.page || 'forms'
            // permissionRoot: permissionRoot // TODO: Backend permissions - will be handled by backend
        }

        const periods = [
            { key: 'week', label: translate('{{lang}}Last Week') },
            { key: 'month', label: translate('{{lang}}Last Month') },
            { key: '3months', label: translate('{{lang}}Last 3 Months') },
            { key: '6months', label: translate('{{lang}}Last 6 Months') },
        ]

        return (
            <div className="w-100" style={{ minHeight: 200 }}>
                {/* Time period selector buttons */}
                <div className="d-flex flex-wrap gap-2 mb-3" style={{ marginBottom: 12 }}>
                    {periods.map((period) => (
                        <button
                            key={period.key}
                            onClick={() => this.setState({ selectedPeriod: period.key })}
                            style={{
                                padding: '6px 16px',
                                borderRadius: 8,
                                border: `2px solid ${this.state.selectedPeriod === period.key ? '#10453d' : '#e5e7eb'}`,
                                backgroundColor: this.state.selectedPeriod === period.key ? '#10453d' : '#fff',
                                color: this.state.selectedPeriod === period.key ? '#fff' : '#10453d',
                                fontSize: 13,
                                fontWeight: 600,
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {period.label}
                        </button>
                    ))}
                </div>

                {/* Chart */}
                <div ref={el => this.chartContainer = el}>
                    <Chart 
                        chartType={chartType}
                        data={chartData}
                        applet={appletValue || undefined}
                        frame={chartData.frame}
                        user={this.props.user}
                        key={this.state.selectedPeriod} // Force re-render when period changes
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({ user: state.user })
const mapDispatchToProps = dispatch => ({})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TimeBasedReportWidget)

